import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../constants/Languages.js';

const ScrollTop = ({ clang, scrollTop }) => {
    return (
        <div className="scroll-top">
            <div className="scroll-top__button">
                <button onClick={scrollTop} title={lang[clang].title.up}>
                    <span className="scroll-top__button-img"></span>
                </button>
            </div>
        </div>
    );
};

ScrollTop.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ScrollTop);



// WEBPACK FOOTER //
// ./src/components/ScrollTop.js